exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/app/shared/navbar/navbar.component.scss
// module id = ../../../../../src/app/shared/navbar/navbar.component.scss
// module chunks = 2